import {RouteRecordRaw} from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    // 회사 정보
    path: '/company/info',
    name: 'CompanyInfo',
    meta: {
      title: '회사 정보',
    },
    components: {
      default: () => import('@/views/company/CompanyInfo.vue'),
      NavBar: () => import('@/components/common/layout/NavBar.vue'),
      SideBar: () => import('@/components/common/layout/SideBar.vue'),
    },
  },
  {
    path: '/company/point',
    name: 'PointContractInfo',
    meta: {
      title: '포인트 계약 정보',
    },
    components: {
      default: () => import('@/views/company/PointContractInfo.vue'),
      NavBar: () => import('@/components/common/layout/NavBar.vue'),
      SideBar: () => import('@/components/common/layout/SideBar.vue'),
    },
  },
];

export default routes;
